import { combineReducers } from 'redux';
import creditCard from './creditCard';
import subscription from './subscription';

export default combineReducers({
  creditCard,
  subscription,
});
